import React from 'react';
import MaterialTable, { MTableToolbar } from 'material-table';
import {Typography} from '@material-ui/core';
import {Link} from 'react-router-dom';

const OtherLeasesTable = ({Tract}) => {
  const commonWidth = '15%'
  const commonHeight = '30px'
  const columns = [
        {
            title: 'Lease',
            field: 'id',
          cellStyle: {
            width: commonWidth,
            height: commonHeight,
            overflow: 'auto',
          },
            render: (rowData) => {
                return (
                    <Link to={`/OtherLeases/${rowData.id}?name=${encodeURIComponent(rowData.projectName)}`} target={'_blank'}>
                        {rowData.projectName}
                    </Link>
                );
            },
        },
    ];

    const data = Tract.otherLeases;

  return (
    <MaterialTable
      columns={columns}
      data={data.map(d => ({...d}))}
      options={{
        paging: false,
        search: false,
        // maxBodyHeight: 'calc(100vh - 150px)',
        // // searchFieldAlignment: 'left',
        // // searchFieldStyle: {
        // //   backgroundColor: '#fff',
        // //   color: '#000',
        // //   border: 'none',
        // //   padding: '4px 8px',
        // //   borderRadius: '4px',
        // // },
        showTitle: false,
        // toolbarButtonAlignment: 'left',
        // addRowPosition: 'first',
        exportButton: false,
        headerStyle: {
          backgroundColor: '#1976d2',
          color: '#FFF',
          textAlign: 'left',
          justifyContent: 'center',
          whiteSpace: 'pre',
        },
      }}
      components={{
        Toolbar: (props) => (
          <div
            style={{
              height: 16,
              width:"100%",
              marginTop: -30,
              backgroundColor: '#1976d2',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              position: 'sticky',
              top: 0,
              zIndex: 20,
            }}
          >
            <MTableToolbar {...props} />
          </div>
        ),
      }}
    />
  );
};

export default OtherLeasesTable;
